import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fixed w-full notification-alert top-[150px]" }

import { reactive, inject } from "vue";
import { Emitter } from "mitt";
import { Alert } from "@/Services/emitter";


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertNotification',
  setup(__props) {

const alerts = reactive<Alert[]>([]);
const emitter: Emitter<{ alert: Alert }> | undefined = inject("emitter");

emitter &&
  emitter.on("alert", ({ message, type, description, interval = 4000 }) => {
    alerts.unshift({
      id: alerts.length,
      message: message,
      type: type || "success",
      description: description,
    });
    setTimeout(() => {
      alerts.length && alerts.pop();
    }, interval);
  });

return (_ctx: any,_cache: any) => {
  const _component_snap_alert_title = _resolveComponent("snap-alert-title")!
  const _component_snap_alert_description = _resolveComponent("snap-alert-description")!
  const _component_snap_alert = _resolveComponent("snap-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alerts, (alert) => {
      return (_openBlock(), _createElementBlock("div", {
        key: alert.id,
        name: "slide-up"
      }, [
        _createVNode(_component_snap_alert, {
          type: alert.type,
          border: true,
          "right-link-text": "Details",
          class: "mb-2 w-fit my-0 mx-auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_snap_alert_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(alert.message), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_snap_alert_description, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(alert.description), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["type"])
      ]))
    }), 128))
  ]))
}
}

})